/* eslint-disable react/prop-types */
import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

const LabelItem = ({ label, index, hiddenLabel, onLabelChange, onDirty, draggableProvided }) => {
  return (
    <InputGroup
      ref={draggableProvided.innerRef}
      {...draggableProvided.draggableProps}
      {...draggableProvided.dragHandleProps}
    >
      <InputGroup.Text className="dragable">
        <img src="/drag_drop_icon.png" alt="Bento Logo" />
      </InputGroup.Text>
      <Form.Control
        className="mt-3"
        id={label.id}
        value={label.value}
        disabled={hiddenLabel}
        type="text"
        onChange={(e) => onLabelChange(e, index)}
        onBlur={onDirty}
      />
    </InputGroup>
  );
};

export default LabelItem;
